export const financeQueryKeys = {
  teamRoleRates: {
    all: () => ['team-role-rates'],
    bulk: (teamRoleIds: number[]) => [
      ...financeQueryKeys.teamRoleRates.all(),
      'bulk',
      [...teamRoleIds].sort((a, b) => a - b),
    ],
  },
  organizationCurrency: {
    all: (organizationId: string) => ['organization-currency', organizationId],
  },
  itemFinancials: {
    all: () => ['item-financials'],
    byItemId: (itemId: number) => [...financeQueryKeys.itemFinancials.all(), 'byItemId', itemId],
    bulk: (itemIds: number[]) => [
      ...financeQueryKeys.itemFinancials.all(),
      'bulk',
      [...itemIds].sort((a, b) => a - b),
    ],
  },
  itemFinancialsAggregate: {
    all: () => ['item-financials-aggregate'],
    bulk: (itemIds: number[]) => [
      ...financeQueryKeys.itemFinancialsAggregate.all(),
      'bulk',
      [...itemIds].sort((a, b) => a - b),
    ],
  },
  loopFinancials: {
    all: () => ['loop-financials'],
    bulk: (loopIds: number[]) => [
      ...financeQueryKeys.loopFinancials.all(),
      'bulk',
      [...loopIds].sort((a, b) => a - b),
    ],
  },
};
